import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.is-integer.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import _createForOfIteratorHelper from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchCreate, fetchUpdate, fetchDetail } from '@/api/PMS/baseInformation/building';
import { fetchTreeList } from '@/api/PMS/treeList/index.js';
import { fetchListByType } from '@/api/PMS/dic/dic';
import selectPosition from './selectPosition';
export default {
  components: {
    selectPosition: selectPosition
  },
  props: ['routerIdArr', 'keyValue', 'showDialog', 'isDetail'],
  data: function data() {
    var checkOrder = function checkOrder(rule, value, callback) {
      setTimeout(function () {
        if (!Number.isInteger(Number(value))) {
          callback(new Error('请输入数字值'));
        } else {
          callback();
        }
      }, 100);
    };

    return {
      ruleForm: {
        upIdList: '',
        buildingName: '',
        buildingOrder: ''
      },
      rules: {
        upIdList: [{
          required: true,
          message: '请选择上级机构',
          trigger: 'blur'
        }],
        buildingName: [{
          required: true,
          message: '请输入名称',
          trigger: 'blur'
        }],
        buildingOrder: [{
          required: true,
          message: '请输入序号',
          trigger: 'blur'
        }, {
          validator: checkOrder,
          trigger: 'blur'
        }]
      },
      propstree: {
        label: 'name',
        value: 'id',
        children: 'pmsTree'
      },
      typeOption: [],
      useOption: [],
      towardOption: [],
      childData: {
        upIdList: []
      },
      options: [],
      cascaderItem: [],
      dialogRecordVisible: false
    };
  },
  computed: {
    coordinate: function coordinate() {
      return {
        longitude: this.childData.lng,
        latitude: this.childData.lat
      };
    }
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      this.typeOption = [];
      this.useOption = [];
      this.cascaderItem = [];
      this.towardOption = [];
      this.loadTypeOptions();
      this.loadUseOptions();
      this.loadTowardOptions();
      this.loadMenuTree();
      this.$nextTick(function () {
        _this.$refs['dataForm'].clearValidate();
      });

      if (this.keyValue > 0) {
        var queryData = {
          id: this.keyValue
        };
        fetchDetail(queryData).then(function (response) {
          _this.childData = response.data.data;
          _this.childData.upIdList = _this.childData.upIdList.join(',').split(',');
        });
      } else {
        this.childData = {};
        this.childData.upIdList = this.routerIdArr;
        setTimeout(function () {
          _this.getCascaderItem(_this.childData.upIdList, _this.options);
        }, 1000);
      }
    },
    receiveCoordinate: function receiveCoordinate(obj) {
      this.$set(this.childData, 'lng', obj.longitude);
      this.$set(this.childData, 'lat', obj.latitude);
    },
    // 获取具体的下拉选项的数据
    getCascaderItem: function getCascaderItem(val, opt) {
      var _this2 = this;

      return val.map(function (value, index, arr) {
        var _iterator = _createForOfIteratorHelper(opt),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;

            if (item.id === value) {
              opt = item.pmsTree;

              _this2.cascaderItem.push(item);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    },
    getNode: function getNode() {
      this.cascaderItem = [];
      this.getCascaderItem(this.childData.upIdList, this.options);
    },
    loadMenuTree: function loadMenuTree() {
      var _this3 = this;

      var treeQuery = {
        flag: 1
      };
      fetchTreeList(treeQuery).then(function (response) {
        _this3.options = response.data.data;
      });
    },
    loadTypeOptions: function loadTypeOptions() {
      var _this4 = this;

      fetchListByType('building_type').then(function (r) {
        _this4.typeOption = r.data.data;
      });
    },
    loadUseOptions: function loadUseOptions() {
      var _this5 = this;

      fetchListByType('building_use').then(function (r) {
        _this5.useOption = r.data.data;
      });
    },
    loadTowardOptions: function loadTowardOptions() {
      var _this6 = this;

      fetchListByType('building_toward').then(function (r) {
        _this6.towardOption = r.data.data;
      });
    },
    changeTypeValue: function changeTypeValue(val) {
      var obj = {};
      obj = this.locations.find(function (item) {
        return item.buildingType === val;
      });
      this.childData.buildingType = obj.dicName;
    },
    changeUseValue: function changeUseValue(val) {
      var obj = {};
      obj = this.locations.find(function (item) {
        return item.dicValue === val;
      });
      this.childData.buildingUse = obj.dicName;
    },
    changeTowardValue: function changeTowardValue(val) {
      var obj = {};
      obj = this.locations.find(function (item) {
        return item.dicValue === val;
      });
      this.childData.menuVueTarget = obj.dicName;
    },
    handCreate: function handCreate() {
      var _this7 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          _this7.childData.areaGroupId = _this7.childData.upIdList[_this7.childData.upIdList.length - 1];

          if (_this7.keyValue > 0) {
            delete _this7.childData.upIdList;
            fetchUpdate(_this7.childData).then(function () {
              _this7.$emit('handCancle', true);

              _this7.Alert({
                alertType: 'update'
              });
            });
          } else {
            if (_this7.childData.buildingOrder == null || _this7.childData.buildingOrder == '') {
              _this7.childData.buildingOrder = 0;
            }

            delete _this7.childData.upIdList;
            fetchCreate(_this7.childData).then(function () {
              _this7.$emit('handCancle', true);

              _this7.Alert({
                alertType: 'add'
              });
            });
          }
        } else {
          _this7.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', 'buildingAdd');
    },
    handleInnerCancle: function handleInnerCancle() {
      this.dialogRecordVisible = false;
    }
  }
};